import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
} from "reactstrap";
import { useAppDispatch } from "src/store";
import {
  createPaymentSettingSaga,
  getPaymentSettingSaga,
  updatePaymentSettingSaga,
} from "src/store/paymentSettings/saga";
import {
  PaymentSettingDto,
  WebPaymentTypeEnum,
} from "src/store/paymentSettings/type";

const PaymentProviderPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [settingId, setSettingId] = useState<string | undefined>();
  const [stripeKey, setStripeKey] = useState<string>("");
  const [provider, setProvider] = useState<number>(WebPaymentTypeEnum.Iyzico);

  const load = () => {
    dispatch(
      getPaymentSettingSaga({
        payload: {
          onSuccess: (_m, res: PaymentSettingDto) => {
            if (res) {
              setSettingId(res.Id);
              setStripeKey(res.StripeKey ?? "");
              // Anything other than an explicit Stripe selection behaves as Iyzico.
              setProvider(
                res.WebPaymentTypeId === WebPaymentTypeEnum.Stripe
                  ? WebPaymentTypeEnum.Stripe
                  : WebPaymentTypeEnum.Iyzico
              );
            }
          },
          onError: () => {},
        },
      })
    );
  };

  useEffect(() => {
    load();
  }, []);

  const onSave = () => {
    const body: any = {
      WebPaymentTypeId: provider,
      StripeKey: stripeKey ?? "",
    };
    const onSuccess = (message: string) => {
      toast.success(message || t("Kaydedildi").toString(), { theme: "colored" });
      load();
    };
    const onError = (message: string) => {
      toast.error(message, { theme: "colored" });
    };

    if (settingId) {
      dispatch(
        updatePaymentSettingSaga({
          payload: { onSuccess, onError },
          id: settingId,
          body: { ...body, Id: settingId },
        })
      );
    } else {
      dispatch(
        createPaymentSettingSaga({
          payload: { onSuccess, onError },
          body,
        })
      );
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row className="justify-content-center">
            <Col xl={7} lg={9}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-1">Ödeme Sağlayıcı</h4>
                  <p className="text-muted mb-4">
                    Aktif ödeme sağlayıcısını seçin. Seçilen sağlayıcı tüm paket
                    ödeme akışını yönlendirir (kart kaydı ve tahsilat).
                  </p>

                  <div className="mb-4">
                    <Label className="form-label">Sağlayıcı</Label>
                    <Input
                      type="select"
                      value={provider}
                      onChange={(e) => setProvider(Number(e.target.value))}
                    >
                      <option value={WebPaymentTypeEnum.Iyzico}>
                        iyzico (Türkiye)
                      </option>
                      <option value={WebPaymentTypeEnum.Stripe}>
                        Stripe (Global)
                      </option>
                    </Input>
                    <small className="text-muted">
                      {provider === WebPaymentTypeEnum.Stripe
                        ? "Stripe seçili: kartlar Stripe'a kaydedilir, tahsilat Stripe üzerinden yapılır."
                        : "iyzico seçili: mevcut iyzico/3D Secure akışı kullanılır."}
                    </small>
                  </div>

                  <div className="mb-4">
                    <Label className="form-label">
                      Stripe Anahtarı (opsiyonel)
                    </Label>
                    <Input
                      type="text"
                      value={stripeKey}
                      placeholder="sk_live_... (boş bırakılırsa sunucu ayarındaki anahtar kullanılır)"
                      onChange={(e) => setStripeKey(e.target.value)}
                    />
                    <small className="text-muted">
                      Yeni Stripe abonelik akışı anahtarı sunucu yapılandırmasından
                      (StripeKeys) okur; bu alan eski entegrasyon içindir.
                    </small>
                  </div>

                  <div className="text-end">
                    <Button color="primary" onClick={onSave}>
                      Kaydet
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PaymentProviderPage;
